<template>
    <div style="width: 100%; height: 100%">
        <table id="printArea" ref="printArea" style="width: 100%" v-loading="loadingInvoiceInfo">
            <tr><td colspan="6"></td><td colspan="2"><span>流水号：{{invoiceInfo.sn}}</span></td></tr>
            <tr><td colspan="3"></td><td colspan="2" style="text-align: center"><span>{{invoceName}}</span></td><td colspan="3"></td></tr>
            <tr><td colspan="8"><span>收费日期：{{invoiceInfo.payTime}}</span></td></tr>
            <tr>
                <td colspan="3"><span>单位名称/业主姓名：{{invoiceInfo.roomCusName}}</span></td>
                <td colspan="2"></td>
                <td colspan="3"><span>房号：{{invoiceInfo.floorName}}/{{invoiceInfo.roomName}}</span></td>
            </tr>
            <tr>
                <td class="min-cell"><span>收费项目</span></td>
                <td class="min-cell"><span>上期读数</span></td>
                <td class="min-cell"><span>本期读数</span></td>
                <td class="min-cell"><span>使用{{invoiceInfo.unit}}数</span></td>
                <td class="min-cell"><span>应缴(元)</span></td>
                <td class="min-cell"><span>实缴(元)</span></td>
                <td class="min-cell"><span>付款方式</span></td>
                <td class="min-cell"><span>备注</span></td>
            </tr>
            <tr>
                <td class="min-cell"><span>实际使用{{invoiceInfo.simpleMeterType}}费</span></td>
                <td class="min-cell"><span>{{invoiceInfo.beforeNum}}</span></td>
                <td class="min-cell"><span>{{invoiceInfo.nowNum}}</span></td>
                <td class="min-cell"><span>{{diffNum}}</span></td>
                <td class="min-cell"><span>{{invoiceInfo.mustAmount}}</span></td>
                <td class="min-cell"><span>{{invoiceInfo.payAmount}}</span></td>
                <td class="min-cell"><span>{{invoiceInfo.payModeStr}}</span></td>
                <td class="min-cell"><span>根据实际使用情况实时变动</span></td>
            </tr>
            <tr>
                <td class="min-cell"><span>预存{{invoiceInfo.simpleMeterType}}费</span></td>
                <td class="min-cell"><span>-</span></td>
                <td class="min-cell"><span>-</span></td>
                <td class="min-cell"><span>-</span></td>
                <td class="min-cell"><span>{{invoiceInfo.preMoney}}</span></td>
                <td class="min-cell"><span>-</span></td>
                <td class="min-cell"><span>-</span></td>
                <td class="min-cell"><span>-</span></td>
            </tr>
            <tr>
                <td class="min-cell"><span>实收合计</span></td>
                <td colspan="4"><span>人民币（大写）：{{invoiceInfo.payAmountCNY}}</span></td>
                <td class="min-cell"><span>{{invoiceInfo.payAmount}}</span></td>
                <td class="min-cell"><span>-</span></td>
                <td class="min-cell"><span>-</span></td>
            </tr>
            <tr>
                <td colspan="8"><span>联系地址及电话：{{invoiceInfo.address}}  {{invoiceInfo.phone}}</span></td>
            </tr>
            <tr>
                <td colspan="2"></td>
                <td colspan="4" style="text-align: center"><span>第一联客户联（白色） 第二联存根联（红色）</span></td>
                <td colspan="2"></td>
            </tr>
            <tr style="height: 80px">
                <td style="width: 200px" colspan="3">
                    <span>收款单位名称(章)</span>
                    <img style="width: 240px" :src="seal">
                </td>
                <td colspan="2"></td>
                <td colspan="3"><span>收款人：{{invoiceInfo.createByStr}}</span></td>
            </tr>
        </table>
        <div style="margin-left: 45%; margin-top: 20px" class="search-button-tools">
            <el-button size="small" v-debounce v-print="'#printArea'">打印</el-button>
            <el-button size="small" v-debounce @click="doExport">导出</el-button>
            <el-button size="small" @click="doBack">返回</el-button>
        </div>
    </div>
</template>
<script>
import { get } from "@/assets/common/request";
import {exportExcel} from '@/assets/common/exportExcel';
import dlg from "@/mixin/dlg";
import NP from "number-precision";
export default {
    name: "Invoice",
    mixins: [dlg],
    props: {
        orderId: {
            type: String,
            default: function() {
                return ''
            }
        }
    },
    components: { },
    data() {
        return {
            loadingInvoiceInfo: false,
            invoiceInfo: {},
            mainId: '',
        }
    },
    methods: {
        loadInvoiceInfo() {
            this.loadingInvoiceInfo = true;
            const url = `meter/web/order/invoiceInfo/${this.mainId}`;
            get(url)
            .then((data) => {
                this.invoiceInfo = data.data;
            })
            .finally(() => {
                this.loadingInvoiceInfo = false;
            });
        },
        doExport() {
            exportExcel('printArea', this.invoceName);
        },
        doBack() {
            const flag = this.doClose();
            if(!flag) {
                this.$router.back(-1);
            }
        }
    },
    computed: {
        seal() {
            if(this.invoiceInfo.projectId) {
                try {
                    return require(`/src/assets/images/seal/${this.invoiceInfo.projectId}.png`);
                }catch(error) {
                    this.$message('找不到项目的印章, 请联系管理员')
                    console.error(`找不到项目${this.invoiceInfo.projectId}的印章`)
                }
            }else {
                return '';
            }
        },
        invoceName() {
            return `${this.invoiceInfo.projectName||''}收款收据`;
        },
        diffNum() {
            return NP.round(NP.minus(this.invoiceInfo.nowNum || 0, this.invoiceInfo.beforeNum || 0), 2);
        }
    },
    mounted() {
        const routerParams = this.$route.params;
        if(routerParams && routerParams.orderId) {
            this.mainId = routerParams.orderId;   
        }

        if(this.orderId) {
            this.mainId = this.orderId;
        }
        this.loadInvoiceInfo();
    }
}
</script>
<style scoped>
#printArea td{
    padding-left: 5px;
    font-family: cursive;
    /* font-family: serif; */
    font-weight: 900;
}
#printArea table, tr , .min-cell {
    border: 1px solid #ccc;
    font-weight: 500;
}
#printArea tr {
    height: 40px;
    line-height: 40px;
}
.min-cell {
    width: 12.5%;
}
.footer {
    height: 80px;
}
.seal {
    widows: 240px;
}
</style>